export default __webpack_public_path__ + "static/media/favorite_icon-big.70d19b6d.svg";